// extracted by mini-css-extract-plugin
module.exports = {"container":"jJ-z","recos":"kJ-z","productCardOverride":"lJ-z"};